import React         from "react";
import { useSpring } from "react-spring";

import Presentation from "./presentation";

const component = ( { change, children } ) => {
	const style = useSpring ( {
		position : "fixed",
		zIndex   : "3",
		bottom   : change ? "0px" : "-75px",
		width    : "100%"

	} );

	return (
		<Presentation
			style = { style }
		>
			{children}
		</Presentation>
	);
};

export default component;
